import request, { METHODS } from "src/utils/api-base";

const reportApis = {
  runReport: (params: {
    type: string;
    dateFrom?: string;
    dateTo?: string;
    productId?: string;
    warehouseId?: string;
    customerId?: string;
    supplierId?: string;
    fromWarehouseId?: string;
    toWarehouseId?: string;
    page?: number;
    limit?: number | "all";
  }) => {
    return request({
      route: "/app/reports",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },
};

export default reportApis;
